// export const ProdEnv = {
//     API_URL: process.env.REACT_APP_API_URL,
//     CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
//     BASE_URL: process.env.REACT_APP_BASE_URL
// };

// config/env.js
export const ProdEnv = {
    BASE_URL: process.env.REACT_APP_BASE_URL || "http://98.95.131.43/api",
    API_URL: process.env.REACT_APP_API_URL || "http://98.95.131.43/api/",
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID || "DevClientId"
};